export default "__VITE_ASSET__BEJnCozO__"